import { typedDoc, getDocument } from '@/lib/firebase/firestore'
import type { TermsOfServiceDocument } from '@/types'

const tosRef = () => typedDoc<TermsOfServiceDocument>('legalDocuments', 'terms-of-service')

export const legalService = {
  async getTermsOfService(): Promise<TermsOfServiceDocument | null> {
    return getDocument(tosRef())
  },
}
